import { render } from "./InputDate.vue?vue&type=template&id=5632bb00&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=5632bb00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5632bb00"]])

export default __exports__